export const SUPPORTED_PAYMENT_METHODS = [
  {
    id: 'cash',
    name: 'Barzahlung',
    type: 'cash',
    enabled: true,
    description: 'Barzahlung direkt an der Kassa',
  },
  {
    id: 'card',
    name: 'Kartenzahlung GP tom',
    type: 'card',
    enabled: true,
    description: 'GP tom Terminal am Smartphone oder Tablet',
    terminal_type: 'gptom_cloud',
    provider: 'gptom',
  },
  {
    id: 'card_sumup',
    name: 'Kartenzahlung SumUp',
    type: 'card',
    enabled: false,
    description: 'SumUp Solo via Cloud API fuer die browserbasierte Kassa',
    terminal_type: 'sumup_solo_cloud',
    provider: 'sumup',
  },
  {
    id: 'card_manual',
    name: 'Kartenzahlung Manuell (Bankomat)',
    type: 'card',
    enabled: true,
    description: 'Zahlung auf externem Bankomatgeraet, danach manuell bestaetigen',
    terminal_type: 'manual',
    provider: 'manual_terminal',
  },
  {
    id: 'bank_transfer',
    name: 'Ueberweisung',
    type: 'other',
    enabled: true,
    description: 'Zahlung wird als Ueberweisung verbucht',
    terminal_type: 'bank_transfer',
    provider: 'bank_transfer',
  },
  {
    id: 'customer_card',
    name: 'Kundenkarte',
    type: 'other',
    enabled: true,
    description: 'Kundenkarte oder Kundenkonto belasten und danach im POS bestaetigen',
    terminal_type: 'customer_card',
    provider: 'customer_card',
  },
  {
    id: 'internal',
    name: 'Eigenverbrauch',
    type: 'internal',
    enabled: true,
    description: 'Interne Buchung fuer Eigenverbrauch',
    terminal_type: 'internal',
    provider: 'internal',
  },
];

export function normalizePaymentMethods(rawMethods) {
  const savedById = new Map(
    (Array.isArray(rawMethods) ? rawMethods : [])
      .filter((method) => method?.id)
      .map((method) => [method.id, method]),
  );

  return SUPPORTED_PAYMENT_METHODS.map((baseMethod) => ({
    ...baseMethod,
    ...(savedById.get(baseMethod.id) || {}),
    id: baseMethod.id,
    type: baseMethod.type,
  }));
}

export function getEnabledPaymentMethods(rawMethods) {
  return normalizePaymentMethods(rawMethods).filter((method) => method.enabled !== false);
}

export function isCashPaymentMethod(methodId) {
  return String(methodId || '').trim().toLowerCase() === 'cash';
}

export function isCardPaymentMethod(methodId) {
  return ['card', 'card_sumup', 'card_manual'].includes(String(methodId || '').trim().toLowerCase());
}

export function isIntegratedCardPaymentMethod(methodId) {
  return ['card', 'card_sumup'].includes(String(methodId || '').trim().toLowerCase());
}

export function getPaymentMethodLabel(methodId) {
  const normalized = String(methodId || '').trim().toLowerCase();
  if (normalized === 'cash') return 'Barzahlung';
  if (normalized === 'card') return 'Kartenzahlung';
  if (normalized === 'card_sumup') return 'Kartenzahlung SumUp';
  if (normalized === 'card_manual') return 'Kartenzahlung Manuell (Bankomat)';
  if (normalized === 'bank_transfer') return 'Ueberweisung';
  if (normalized === 'customer_card') return 'Kundenkarte';
  if (normalized === 'internal') return 'Eigenverbrauch';
  return normalized || 'Unbekannt';
}

export function isGpTomConfigured(settings) {
  return Boolean(
    settings?.gp_enabled
    && String(settings?.gp_tom_api_key || '').trim()
    && String(settings?.gp_tom_username || '').trim()
    && String(settings?.gp_tom_password || '').trim()
    && String(settings?.gp_tom_tid || '').trim(),
  );
}

export function isSumUpConfigured(settings) {
  return Boolean(
    settings?.sumup_enabled
    && String(settings?.sumup_api_key || '').trim()
    && String(settings?.sumup_merchant_code || '').trim()
    && String(settings?.sumup_affiliate_key || '').trim()
    && String(settings?.sumup_affiliate_app_id || '').trim()
    && String(settings?.sumup_reader_id || '').trim(),
  );
}
